<template>
  <div>
    <div class="container">
      <h5 class="vue-title headderFont">
        <strong>{{ $t("USERDETAILS") }}</strong>
      </h5>
      <!-- user details -->
      <p class="userDetails">
        <p>
          <strong>{{ $t("FULLNAME") }}：</strong>{{ userDetails.last_name + " " + userDetails.first_name }}
          <strong class="ml-3">{{ $t("GENDER") }}：</strong>{{ genderString }}
          <strong class="ml-3">{{ $t("AGE") }}：</strong>{{ ageString }}
        </p>
        <p>
          <strong>{{ $t("PHONENUMBER") }}：</strong>{{ phoneNumberString }}
          <strong class="ml-3">{{ $t("EMAIL") }}：</strong>{{ userDetails.email }}
        </p>
        <p>
          <strong>{{ $t("PATIENT_VR_ID") }}：</strong>{{ userDetails.vr_id ? userDetails.vr_id : "(未設定)" }}
        </p>
      </p>

      <router-view class="mt-3"></router-view>

    </div>
  </div>
</template>

<script>
import {GET_SERVEY_DETAILS,} from "@/store/actions.type";
export default {
  name: "user-details",
  data() {
    return {
      age: 0 /* Default age field  should be 0 */,
      isLoading: false,
      userDetails: ""
    };
  },
  computed: {
    genderString: function () {
      if (this.userDetails.gender === "male") {
        return "男性";
      } else if (this.userDetails.gender === "female") {
        return "女性";
      } else if (this.userDetails.gender === "other") {
        return "その他";
      } else {
        return "回答なし";
      }
    },
    ageString: function () {
      if (this.userDetails.date_of_birth === null) {
        return "回答なし";
      }

      let toDateString = function(date){ // "20210101"のような表記に変換する
        // `getMonth()+1`はgetMonthの結果は0から11という仕様に対応するため
        return ""+date.getFullYear()+("0"+(date.getMonth()+1)).slice(-2)+("0"+date.getDate()).slice(-2);
      }
      let birthDate = new Date(this.userDetails.date_of_birth);
      let todayDate = new Date();
      let ageNumber = Math.floor((parseInt(toDateString(todayDate)) - parseInt(toDateString(birthDate))) / 10000);

      return String(ageNumber) + "歳";
    },
    phoneNumberString: function () {
      return this.userDetails.contact_no || "回答なし";
    }
  },
  methods: {
  },
  async created() {
    this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
    this.params = this.$route.params;
    let response = await this.$store.dispatch(GET_SERVEY_DETAILS, {
      user_id: this.params.patientId
    });
    this.isLoading.hide();
    if (_.get(response, "status", false)) {
      this.userDetails = response.user;
    } else {
      this.$toast.error({
        message:  _.get(response, "message", "")
      });
      this.$router.push({
        name: "user"
      });
    }
  }
};
</script>

<style>
.container {
  margin: auto;
}
.headderFont {
  margin-top: 14px;
}
.userDetails {
  margin-top: 10px;
}
</style>
